const CustomResourceApplyXXL = () => import('@/views/main/report/customResourceApply/CustomResourceApplyXXL.vue')
export default {
  path: '/main/report/customResourceApplyXXL',
  name: 'customResourceApplyXXL',
  component: CustomResourceApplyXXL,
  children: []
}
